import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileText, Clock, ScanLine, MessageSquare, Trophy, BookOpen, Upload, GitBranch, Settings } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const navItems = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/test/setup", icon: FileText, label: "New Test" },
  { to: "/history", icon: Clock, label: "History" },
  { to: "/pyq", icon: BookOpen, label: "Previous Years" },
  { to: "/topics", icon: GitBranch, label: "Topic Map" },
  { to: "/seeder", icon: Upload, label: "Seed Questions" },
  { to: "/omr", icon: ScanLine, label: "OMR Mode" },
  { to: "/feedback", icon: MessageSquare, label: "Feedback" },
  { to: "/admin", icon: Settings, label: "Admin Tools" },
];

export default function Sidebar() {
  const [redemption, setRedemption] = useState(null);

  useEffect(() => {
    axios.get(`${API}/redemption/status`).then(r => setRedemption(r.data)).catch(() => {});
  }, []);

  return (
    <nav
      data-testid="sidebar-nav"
      className="w-64 bg-card border-r border-border flex flex-col shrink-0 h-screen sticky top-0"
    >
      <div className="p-6 border-b border-border">
        <h1 className="font-heading text-xl font-bold tracking-tight text-foreground">
          Civils Practice Lab
        </h1>
        <p className="text-xs text-muted-foreground mt-1 uppercase tracking-widest">
          UPSC Prelims 2026
        </p>
      </div>

      <div className="flex-1 p-4 space-y-1">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-all duration-200 ${
                isActive
                  ? "bg-primary/10 text-primary border-l-2 border-primary"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
              }`
            }
          >
            <Icon size={18} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>

      {/* Redemption Mode Status */}
      <div className="p-4 border-t border-border">
        <div
          data-testid="redemption-status"
          className={`p-3 rounded-sm ${
            redemption?.eligible
              ? "bg-amber-500/10 border border-amber-500/30"
              : "bg-secondary/50"
          }`}
        >
          <div className="flex items-center gap-2 mb-1">
            <Trophy size={16} className={redemption?.eligible ? "text-amber-500" : "text-muted-foreground"} />
            <span className="text-xs font-semibold uppercase tracking-wider">
              Redemption Mode
            </span>
          </div>
          {redemption?.eligible ? (
            <p className="text-xs text-amber-400">Unlocked! Target your weak areas.</p>
          ) : (
            <p className="text-xs text-muted-foreground">
              {redemption ? `${redemption.tests_needed} more tests to unlock` : "Loading..."}
            </p>
          )}
          {redemption?.eligible && (
            <Badge variant="outline" className="mt-2 text-xs border-amber-500/50 text-amber-400">
              Active
            </Badge>
          )}
        </div>
      </div>
    </nav>
  );
}
